import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NavBarAction, NavbarItem } from '@timechef/core/models/app';

@Component({
  selector: 'app-navbar-item',
  templateUrl: './navbar-item.component.html',
  styleUrls: ['./navbar-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarItemComponent {
  @Input() item!: NavbarItem;
  @Input() hideText = false;
  @Input() size: string = '';

  @Output() triggerAction = new EventEmitter<NavBarAction>();

  @HostListener('click', ['$event'])
  onClick(event: any) {
    if (this.item.action) {
      event.stopPropagation();
      event.preventDefault();
      this.triggerAction.emit(this.item.action);
    }
  }
}
